import { Link } from "react-router-dom";
import { HeartHandshake } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HOME } from "@/constants/testIds";

export default function GetInvolvedBand() {
  return (
    <section className="bg-zinc-950 text-white border-b border-zinc-800 py-14">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <HeartHandshake className="h-8 w-8 text-[#4FD1C5] mx-auto mb-4" />
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#4FD1C5] mb-3">Become a Friend of BAP</p>
        <h2 className="font-display font-extrabold uppercase text-2xl md:text-3xl tracking-tight mb-4">
          You Don't Have to Experience Bias to Help Change It
        </h2>
        <p className="text-zinc-300 max-w-xl mx-auto mb-8 leading-relaxed">
          Give your time, voice, expertise, connections, resources — or simply stand with us. Every kind of
          support moves this movement forward.
        </p>
        <Link to="/guidelines?tab=resources#volunteer-section" data-testid={HOME.getInvolvedButton}>
          <Button size="lg" className="bg-[#4FD1C5] text-zinc-950 font-semibold rounded-none px-10 py-6 text-base hover:bg-white transition-all">
            Get Involved
          </Button>
        </Link>
      </div>
    </section>
  );
}
